import React from 'react'
import PropTypes from 'prop-types'

const PublishStatusFilter = (props) => {
  const trueValue = true
  const falseValue = false
  return (
    <select
      className="filter-header"
      onChange={props.onChangePublishStatus}
    >
      <option value={''}>PUBLISH STATUS</option>
      <option value={trueValue}>Published</option>
      <option value={falseValue}>Unpublished</option>
    </select>
  )
}

PublishStatusFilter.propTypes = {
  onChangePublishStatus: PropTypes.func.isRequired,
}

export default PublishStatusFilter
